// import external dependencies
import $ from 'jquery';
import jQuery from 'jquery';
import 'bootstrap';
//window.Popper = require('popper.js')
import 'slick-carousel';
import mapboxgl from 'mapbox-gl';

// Import FontAwesome
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faBars, faUser, faSpinner, faSearch, faCheck, faAngleRight, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { faTwitter, faFacebookF, faYoutube, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
library.add(faEnvelope, faTwitter, faFacebookF, faYoutube, faInstagram, faBars, faUser, faSpinner, faLinkedinIn, faSearch, faCheck, faAngleRight);
dom.watch()



//LAZY LOAD !!
document.addEventListener("DOMContentLoaded", function() {
    let lazyloadImages = document.querySelectorAll("img.lazy");
    let lazyloadSources = document.querySelectorAll("source.lazy");
    let lazyloadThrottleTimeout;

    function lazyload () {

        if(lazyloadThrottleTimeout) {
            clearTimeout(lazyloadThrottleTimeout);
        }

        lazyloadThrottleTimeout = setTimeout(function() {

            lazyloadImages = document.querySelectorAll("img.lazy");
            lazyloadSources = document.querySelectorAll("source.lazy");
            //console.log('lazyload '+lazyloadSources.length);

            let scrollTop = window.pageYOffset;
            $.each(lazyloadImages, function(index, img) {
                if(img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                }
            });
            $.each(lazyloadSources, function(index, img) {
                if(img.offsetTop < (window.innerHeight + scrollTop)) {
                    img.srcset = img.dataset.srcset;
                    img.classList.remove('lazy');
                }
            });
            if(lazyloadSources.length == 0 && lazyloadImages.length == 0) {
                window.removeEventListener("scroll", lazyload);
                window.removeEventListener("resize", lazyload);
                window.removeEventListener("orientationChange", lazyload);
            }
        }, 20);

        let imgDefer = document.querySelectorAll('div[data-srcbg]');
        let style = "background-image: url({url})";
        for (let i = 0; i < imgDefer.length; i++) {

            imgDefer[i].setAttribute('style', style.replace("{url}", imgDefer[i].getAttribute('data-srcbg')));

        }
    }

    window.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
    //window.dispatchEvent(new Event('resize'));
    // IE
    let evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});





/********* STICKY MENU **********/
var stickyNavTop = $('#wrapper-navbar').offset().top;

var stickyNav = function(){
  var scrollTop = $(window).scrollTop();

  if (scrollTop > stickyNavTop) {
      $('#wrapper-navbar').addClass('sticky');
  } else {
      $('#wrapper-navbar').removeClass('sticky');
  }
};

stickyNav();

$(window).scroll(function() {
    stickyNav();
});



jQuery(document).ready(function() {

  var initHome = function(){

    if($('.home-slider').length > 0){
      $('.home-slider .home-carousel').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots:true,
          fade: true,
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0
      });

      setTimeout(
      function()
      {
        $('.text-1').animate({ opacity: '1' }, 1000); // On revoit l'image à sa "vrai" position
      }, 500);

      setTimeout(
      function()
      {
        $('.text-2').animate({ opacity: '1' }, 800); // On revoit l'image à sa "vrai" position
      }, 1000);


    }
  }

  var initMenu = function(){

    if($('body.home').length == 0 && $('#wrapper-navbar.sticky').length == 0){
      var myCollapsible = document.getElementById('navbarNavDropdown')
      myCollapsible.addEventListener('show.bs.collapse', function () {
        $('header .navbar-brand').addClass('invert');
      });
      myCollapsible.addEventListener('hidden.bs.collapse', function () {
        $('header .navbar-brand').removeClass('invert');
      });
    }
  }

  var initBlocs = function(){
    if($('.slider-2columns-list-block').length > 0){
      $('.slider-2columns-list-block .slide').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots:true,
          fade: false,
          autoplay: false,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0,
          speed: 50,
      });

      /*$('.slider-2columns-list-block .slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var cpt = $(slick.$slides.get(currentSlide)).data('cpt');
        cpt++;
        $('.slider-2columns-list-block ul a').removeClass('active');
        if($('.slider-2columns-list-block ul a.cpt-'+cpt).length > 0){
          $('.slider-2columns-list-block ul a.cpt-'+cpt).addClass('active');
        }
        else {
          $('.slider-2columns-list-block ul a.cpt-1').addClass('active');
        }
      });*/


      $('.slider-2columns-list-block ul a').hover(
        function() {
          //$('.slider-2columns-list-block .slide').slick('slickPause');
          /*$('.slider-2columns-list-block ul a').removeClass('active');
          $(this).addClass('active');*/
          console.log(($(this).data('cpt')-1));
          $('.slider-2columns-list-block .slide').slick('slickGoTo', +($(this).data('cpt')-1));
        }, function() {
          //$('.slider-2columns-list-block .slide').slick('slickPlay');
        }
      );

    }


    if($('.list-slick-3').length > 0){
      $('.list-slick-3').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots:false,
          fade: false,
          autoplay: false,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true,
                autoplay: true,
              }
            }
          ]
      });

    }

    if($('.resources-place-block').length > 0){
      $('.resources-place-block .list').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          dots:false,
          fade: false,
          autoplay: false,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true,
                arrows: false,
                autoplay: true,
              }
            }
          ]
      });

      /*$('.resources-place-block .list .item a').hover(function(){
        var id = $(this).data('id');
        $('.imghover').removeClass('active');
        $('.imghover.id-'+id).addClass('active');
        $('.resources-place-block .title').addClass('active');
      },
      function(){
        $('.imghover').removeClass('active');
        $('.resources-place-block .title').removeClass('active');
      }
    );*/
    }

    if($('.projects-block').length > 0){
      $('.projects-block .list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots:false,
          fade: false,
          autoplay: false,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0
      });
    }

    if($('.partners-block').length > 0){
      $( ".partners-block .slick-slider" ).each(function() {
        $(this).slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: false,
            dots:true,
            fade: false,
            autoplay: true,
            infinite: false,
            lazyLoad: 'ondemand',
            rows: 0,
            //mobileFirst: true,
            /*responsive: [
               {
                  breakpoint: 768,
                  settings: "unslick"
               }
            ]*/
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  dots:true,
                  arrows: false,
                  autoplay: true,
                }
              }
            ]
        });
      });
    }


    if ($('.accordion-block .collapse-toggler').length > 0){
      $('.accordion-block .collapse-toggler').on('click', function () {
        let target = $(this).attr('href');
        $(target).toggleClass('invisible');
        $(target).toggleClass('visible');
        $(this).toggleClass('actif');

        return false; // cancel link
      });
    }


    if($('.testimonies-slider').length > 0){
      $('.testimonies-slider').slick({
          centerMode: true,
          centerPadding: '200px',
          slidesToShow: 1,
          arrows: false,
          dots:true,
          autoplay: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true,
                centerPadding: '0px',
              }
            }
          ]
      });

      $('.testimonies-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

        $('.testimonies-slider .slick-slide').removeClass('active');
        $('.testimonies-slider .slick-slide').eq((nextSlide-1)).addClass('active');
        //$('.testimonies-slider .slick-slide').eq((currentSlide+1)).addClass('active');
      });
    }



    if($('.accommodation-block .item .header').length > 0){
      $('.accommodation-block .item .header a.btn').hover(
        function() {
          $(this).parent().addClass('active');
        }, function() {
          $(this).parent().removeClass('active');
        }
      );
    }
    if($('.programs-list .programs-list__item').length > 0){
      $('.programs-list .programs-list__item a.btn-primary').hover(
        function() {
          $(this).parent().parent().addClass('active');
        }, function() {
          $(this).parent().parent().removeClass('active');
        }
      );
    }



  }

  function entierAleatoire(min, max)
  {
   return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  var initThematiques = function(){
    if($('.thematiques-block').length > 0){
      $('.thematiques-block .theme').click(function(e){
        e.preventDefault();
        var random = [0,5,10,15,20];
        var coords = [];
        $('.thematiques-block .words').removeClass('active');
        $('.thematiques-block .words li span').css({opacity:'0'});
        $('.thematiques-block .inner').addClass('active');
        $(this).parent().find('.words').addClass('active');
        $(this).parent().find('.words li').each(function( index ) {
          $(this).find('span').animate({
            opacity: 1}, entierAleatoire(0, 1000), function() {
            // Animation complete.
          });

          var x = random[entierAleatoire(0, 4)];
          var y = random[entierAleatoire(0, 4)];
          while(jQuery.inArray(x+";"+y, coords) > -1){
            x = random[entierAleatoire(0, 4)];
            y = random[entierAleatoire(0, 4)];
            //console.log(x+";"+y);
          }

          var rand = entierAleatoire(0, 1);
          if(rand == 0) $(this).css({left:x+'%',right:'auto'});
          else $(this).css({right:x+'%',left:'auto'});

          rand = entierAleatoire(0, 1);
          if(rand == 0) $(this).css({top:y+'%',bottom:'auto'});
          else $(this).css({bottom:y+'%',top:'auto'});

          coords.push(x+";"+y);
        });
      });
      $('.thematiques-block .words a').click(function(e){
        e.preventDefault();
        $('.thematiques-block .words').removeClass('active');
        $('.thematiques-block .inner').removeClass('active');
      });

      $('.thematiques-block.v2 .list').slick({
          slidesToShow: 5,
          arrows: false,
          dots:false,
          autoplay: true,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true,
              }
            }
          ]
      });

      $('.thematiques-block.v2 .list a.theme').hover(
        function() {
          $('.thematiques-block.v2 .list a.theme').addClass('active');
          $(this).removeClass('active');
        },
        function(){
          $('.thematiques-block.v2 .list a.theme').removeClass('active');
        }
      );

      if ($('.thematiques-block .list .item').length > 0) {

        $('.thematiques-block .list .item').each(function () {

          const current = $(this);
          const initialPosition = $(this).css('bottom');
          // On le baisse de 100px par rapport à sa position initial
          $(this).css('bottom', parseInt($(this).css('bottom')) + 50);
          $(this).css('opacity', 0);

          $(window).on('scroll', function () {
            // Si on arrive au niveau de l'image
            if ($(window).scrollTop() >= ($(current).offset().top - $(window).height() + 300)) {

                setTimeout(
                function()
                {
                  $(current).animate({ bottom: initialPosition, opacity: '1' }, 500); // On revoit l'image à sa "vrai" position
                }, (120*$(current).index()));

            }
          });
        });
      }
    }
  }


  var initKeyfigures = function(){

    if($('.keyfigures-slider').length > 0){
      $('.keyfigures-slider').slick({
          slidesToShow: 5,
          arrows: false,
          dots:false,
          autoplay: true,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true,
              }
            }
          ]
      });
    }


    if($('.keyfigures .count').length > 0){
        var count = false;
        $(window).scroll(function () {

            if(count == false){
                if($(window).scrollTop() >= ($('.keyfigures').offset().top - 300)){
                    count = true;
                    $('.count').each(function () {
                        var nb = $(this).text().replace(' ','');
                        var float = '';
                        var pref = '';
                        //console.log(nb.search(',5'));
                        if(nb.search(',5') != -1){
                          float = ',5';
                          nb = nb.replace(',5', '');
                        }
                        if(nb.indexOf('+') >= 0){
                          pref = '+';
                          nb = nb.replace('+', '');
                        }
                        $(this).prop('Counter',($(this).text()/4)*3).animate({
                            Counter: nb
                        }, {
                            duration: 1000,
                            easing: 'swing',
                            step: function (now) {
                                $(this).text(pref+Math.ceil(now)+float);
                            }
                        });
                    });
                }
            }

        });
    }

  }


  var init_mapbox = function(){ // -----------------------------------------------------------------------
    if( $('#plan').length > 0){

      const lngN = 3.5180585;
      const latN = 50.3735282;
      const markerIconURL = $('#plan').data('markericonurl');
      const descriptionForMarker = $('#plan').data('descriptionformarker');

      // initialisation de la map
      mapboxgl.accessToken = 'pk.eyJ1IjoiYmFlc3RlbGxlIiwiYSI6ImNrdm1paWxnNDB2c3kydW81NmM5bHoxb2cifQ.-HmnvSPQR3BPO0R1sxbWFA';
      var map = new mapboxgl.Map({
          container: 'plan',
          style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
          center: [lngN, latN], // starting position [lng, lat]
          zoom: 15, // starting zoom
      });

      // Ajout du marqueur
      map.on('load', function () {
    		map.loadImage(
          // récupéré par champ ACF, puis passé en data
      		markerIconURL,
      		// Add an image to use as a custom marker
      		function (error, image) {
            // S'il n'y a pas de curseur personnalisé, on charge celui par défaut
        		if (error){
              var marker = new mapboxgl.Marker({
                'color'  : '#000',
                'scale'  : 1
              });

              marker.setLngLat([lngN, latN]);
              marker.addTo(map);
            }
            // On charge le curseur personnalisé
            else{
              map.addImage('custom-marker', image);

              const markers = [];

              /*const markers = [{
                'type': 'Feature',
                'properties': {
                  'description': descriptionForMarker
                },
                'geometry': {
                  'type': 'Point',
                  'coordinates': [lngN, latN]
                }
              }];*/
              $( "#plan .coords" ).each(function( index ) {
                //console.log('here '+$(this).data('coords'));
                markers.push({
                  'type': 'Feature',
                  'properties': {
                    'description': $(this).data('text')
                  },
                  'geometry': {
                    'type': 'Point',
                    'coordinates': [parseFloat($(this).data('lng')), parseFloat($(this).data('lat'))]
                  }
                });
              });

              map.addSource('places', {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': markers
                }
              });

              // Add a layer showing the places.
              map.addLayer({
                'id': 'places',
                'type': 'symbol',
                'source': 'places',
                'layout': {
                  'icon-image': 'custom-marker',
                  'icon-size': 0.14,
                  'icon-anchor': 'bottom',
                  'icon-allow-overlap': true
                }
              });
            }
          }
        );
      });

      // Create a popup, but don't add it to the map yet.
      var popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        anchor:'top'
      });

      map.on('mouseenter', 'places', function (e) {
        // Change the cursor style as a UI indicator.
        map.getCanvas().style.cursor = 'pointer';

        var coordinates = e.features[0].geometry.coordinates.slice();
        var description = e.features[0].properties.description;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += (e.lngLat.lng > coordinates[0]) ? 360 : -360;
        }

        // Populate the popup and set its coordinates
        // based on the feature found.
        popup.setLngLat(coordinates).setHTML(description).addTo(map);
      });

      map.on('mouseleave', 'places', function () {
        map.getCanvas().style.cursor = '';
        popup.remove();
      });

      map.addControl(new mapboxgl.NavigationControl());
      // disable map zoom when using scroll
      map.scrollZoom.disable();
    }
  }


  var initMembers = function(){

    if($('.members-block').length > 0){
      $('.members-block .list').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots:false,
          fade: false,
          autoplay: false,
          infinite: true,
          lazyLoad: 'ondemand',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            }
          ]
      });

      $('.members-block .list .item a.open').click(function(e){
        e.preventDefault();
        $('.members .list .item').removeClass('active');
        $(this).parent().parent().addClass('active');
      });
    }
  }


  var initGutenbergColumns = function(){
    if($('article.page .wp-block-columns.slider').length > 0){
      var numItems = $('article.page .wp-block-columns.slider .wp-block-column').length;
      //console.log(numItems);
      $('article.page .wp-block-columns.slider').slick({
          slidesToShow: parseInt(numItems),
          arrows: false,
          dots:false,
          autoplay: false,
          infinite: false,
          lazyLoad: 'ondemand',
          rows: 0,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                dots:true,
                autoplay:true
              }
            }
          ]
      });
    }
  }

  var initPrograms = function(){
    if ($('.programs-block').length > 0) {
      if ($('.collapse-toggler').length > 0){
        $('.collapse-toggler').on('click', function () {
          let target = $(this).attr('href');
          $(target).toggleClass('invisible');
          $(target).toggleClass('visible');
          $(this).toggleClass('actif');

          return false; // cancel link
        });
      }

      mobileDOM();
      // Lorsque l'on redimensionne l'écran, on vérifie si un changement de style est nécessaire
      window.addEventListener("resize", mobileDOM);

      function mobileDOM(){
        let img = $(".programs-block .programs-list__item div.img");

        if (window.innerWidth <= 767) {

          $(img).each(function(){
            $(this).parent().append($(this));
          });
        }
        else{
          $(img).each(function () {
            if ( $(this).parent().attr("data-disposition") !== '1' ) {
              $(this).parent().prepend($(this))
            }
          });
        }
      }
    }
  }

  var initAnim = function (){
    if ($('.picture.animation').length > 0) {
      $('.picture.animation').each(function () {
        const current = $(this);
        const section = $(current).parent().parent();
        const initialPosition = parseInt($(this).css('top')) - 80;

        // Dans le cas où l'élément est en haut de page, on baisse le top au max possible selon la formule
        if ($(window).height() >= $(section).offset().top){
          $(current).css('top', initialPosition - ($(section).offset().top - $(window).height()) * 0.15 + 'px');
        }
        else{
          $(current).css('top', initialPosition + 'px');
        }

        $(window).on('scroll', function () {
          if ($(window).scrollTop() >= ($(section).offset().top - $(window).height() + 100)) {
            // Récupère une fraction du scroll à partir de l'élément pour donner le "pas", la vitesse de déplacement de l'image
            let moveScroll = (window.pageYOffset - ($(section).offset().top - $(window).height())) * 0.15;

            // On part de la position initiale et on ajoute la fraction de scroll
            $(current).css('top', initialPosition + moveScroll + 'px');
          }
        });
      });
    }

    if ($('.entry-content .wp-block-columns').length > 0) {
      $('.entry-content .wp-block-columns').each(function () {

        if(!$(this).hasClass('animated')){
          $(this).find('.wp-block-column').each(function () {

            const current = $(this);
            const initialPosition = $(this).css('bottom');
            // On le baisse de 100px par rapport à sa position initial
            $(this).css('bottom', parseInt($(this).css('bottom')) + 50);
            $(this).css('opacity', 0);

            $(window).on('scroll', function () {
              // Si on arrive au niveau de l'image
              if ($(window).scrollTop() >= ($(current).offset().top - $(window).height() +200)) {

                  setTimeout(
                  function()
                  {
                    $(current).animate({ bottom: initialPosition, opacity: '1' }, 250); // On revoit l'image à sa "vrai" position
                  }, (150*$(current).index()));

              }
            });

          });
          $(this).addClass('animated');
        }
      });
    }

  }

  var initFadeEffect = function(){
    if ($('.fade-in').length > 0) {
      $('.fade-in').each(function () {
        const current = $(this);
        const initialPosition = $(this).css('bottom');
        // On le baisse de 100px par rapport à sa position initial
        $(this).css('bottom', parseInt($(this).css('bottom')) - 100);

        $(window).on('scroll', function () {
          // Si on arrive au niveau de l'image
          if ($(window).scrollTop() >= ($(current).offset().top - $(window).height() + 100)) {
            if($(current).hasClass('delay')){
              setTimeout(
              function()
              {
                $(current).animate({ bottom: initialPosition, opacity: '1' }, 500); // On revoit l'image à sa "vrai" position
              }, 500);
            }
            else{
              $(current).animate({ bottom: initialPosition, opacity: '1' }, 500); // On revoit l'image à sa "vrai" position
            }
            // TODO: ne sert à rien car l'élement est toujours écouté dans le foreach (toujours la liste)
            $(current).removeClass('fade-in');// Pour qu'il n'essaie pas de relancer l'animation
          }
        });
      });
    }
  }


  var initEvents = function(){
    if( $('.events-block').length > 0 ){

        /***************************
        *     RELOAD MORE LIST
        ***************************/
       var load = false;
       var currentPage = $('.events-block .list').data('paged');
       var maxNumPages = $('.events-block .list').data('max');
       var postsPerPage = $('.events-block .list').data('perpage');
       var foundPosts = $('.events-block .list').data('foundposts');
       var tax = null;

       if (foundPosts > postsPerPage && maxNumPages > 1) {
           $('.events-block .more').show();
       }
       if(currentPage + 1 > maxNumPages) $('.events-block .more').hide();

       $('.events-none .btn-passed').on('click', function(e){
         e.preventDefault();
         $('.events-block .filters .passed').trigger('click');
       });

       $('.events-block .taxs a, .events-block .filters .passed').click(function(e){
         e.preventDefault();
         tax = $(this).data('id');
         $('.events-none-first').hide();

         $('.events-block .filters a').removeClass('selected');
         $(this).addClass('selected');

         $('.events-block .more').hide();

         $.ajax({
             url: $('.events-block .list').data('url'),
             data: {
                 paged: 1,
                 category_id : tax
             },
             success: function(data) {
                 if (data != '') {

                    currentPage = 1;

                    $('.events-block .list').html(data);

                     load = false;
                     $('.events-block .loader').hide();

                     maxNumPages = $('.events-block .list .datas').data('max');
                     foundPosts = $('.events-block .list .datas').data('foundposts');

                    if (currentPage == maxNumPages) {
                        $('.events-block .more').hide();
                    }
                    else if(foundPosts == 0){
                      $('.events-block .more').hide();
                    }
                    else {
                        $('.events-block .more').show();
                    }

                    $('.events-block .result-count').html($('.events-block .list .item').length+' / '+foundPosts);
                    $('.events-block .pages').html('');
                    for(var i=0; i<maxNumPages; i++){
                      $('.events-block .pages').append('<li></li>');
                    }
                    $('.events-block .pages li').first().addClass('active');

                 }

             }
         });
       });

       $('.events-block .more a').click(function(e){
           e.preventDefault();

           if (!load && ($('.events-block .list .item').length >= postsPerPage) && ($('.events-block .list .item').length < foundPosts)) {

               load = true;
               $('.events-block .loader').show();
               $('.events-block .more').hide();

               var nextPage = currentPage + 1;

               if (nextPage <= maxNumPages) {

                   $.ajax({
                       url: $('.events-block .list').data('url'),
                       data: {
                           paged: nextPage,
                           category_id : tax
                       },
                       success: function(data) {
                           if (data != '') {

                              currentPage++;
                              $('.events-block .list').append(data);

                               load = false;
                               $('.events-block .loader').hide();

                              if (nextPage == maxNumPages) {
                                  $('.events-block .more').hide();
                              }
                              else {
                                  $('.events-block .more').show();
                              }
                              $('.events-block .result-count').html($('.events-block .list .item').length+' / '+foundPosts);
                              var page_active = $('.events-block .pages li.active');
                              page_active.next().addClass('active');
                              page_active.removeClass('active');
                           }

                       }
                   });
               }
           }
       });
   }
 }



 var initNews = function(){
   if( $('body.blog #news').length > 0 ){

       /***************************
       *     RELOAD MORE LIST
       ***************************/
      var load = false;
      var currentPage = $('#news .list .nav').data('paged');
      var maxNumPages = $('#news .list .nav').data('max');
      var postsPerPage = $('#news .list .nav').data('perpage');
      var foundPosts = $('#news .list .nav').data('foundposts');
      var tax = null;

      if (foundPosts > postsPerPage && maxNumPages > 1) {
          $('#news .more').show();
      }
      if(currentPage + 1 > maxNumPages) $('#news .more').hide();

      $('#news .taxs .tax a').click(function(e){
        e.preventDefault();
        tax = $(this).data('id');

        $('#news .taxs .tax a').removeClass('selected');
        $(this).addClass('selected');

        $.ajax({
            url: $('#news .list .nav').data('url'),
            data: {
                paged: 1,
                category_id : tax
            },
            success: function(data) {
                if (data != '') {

                   currentPage = 1;

                   $('#news .list .nav').html(data);

                    load = false;
                    $('#news .loader').hide();

                    maxNumPages = $('#news .list .datas').data('max');
                    foundPosts = $('#news .list .datas').data('foundposts');

                   if (currentPage == maxNumPages) {
                       $('#news .more').hide();
                   }
                   else {
                       $('#news .more').show();
                   }

                   $('#news .result-count').html($('#news .list .item').length+' / '+foundPosts);
                   $('#news .pages').html('');
                   for(var i=0; i<maxNumPages; i++){
                     $('#news .pages').append('<li></li>');
                   }
                   $('#news .pages li').first().addClass('active');
                }

            }
        });
      });

      $('#news .more a').click(function(e){
          e.preventDefault();

          if (!load && ($('#news .list .item').length >= postsPerPage) && ($('#news .list .item').length < foundPosts)) {

              load = true;
              $('#news .loader').show();
              $('#news .more').hide();

              var nextPage = currentPage + 1;

              if (nextPage <= maxNumPages) {

                  $.ajax({
                      url: $('#news .list .nav').data('url'),
                      data: {
                          paged: nextPage,
                          category_id : tax
                      },
                      success: function(data) {
                          if (data != '') {

                             currentPage++;
                             $('#news .list .nav').append(data);

                              load = false;
                              $('#news .loader').hide();

                             if (nextPage == maxNumPages) {
                                 $('#news .more').hide();
                             }
                             else {
                                 $('#news .more').show();
                             }
                             $('#news .result-count').html($('#news .list .item').length+' / '+foundPosts);
                             var page_active = $('#news .pages li.active');
                             page_active.next().addClass('active');
                             page_active.removeClass('active');
                          }

                      }
                  });
              }
          }
      });
  }
 }


 var initFormGreenBox = function (){
   if ($('.form-green-box-block').length > 0) {
     $('.form-green-box-block .green.animation').each(function () {
       const current = $(this);
       const section = $(current).parent();
       const initialPosition = parseInt($(this).css('top')) - 80;
       console.log(initialPosition);

       // Dans le cas où l'élément est en haut de page, on baisse le top au max possible selon la formule
       if ($(window).height() >= $(section).offset().top){
         $(current).css('top', initialPosition - ($(section).offset().top - $(window).height()) * 0.15 + 'px');
       }
       else{
         $(current).css('top', initialPosition + 'px');
       }

       $(window).on('scroll', function () {
         if ($(window).scrollTop() >= ($(section).offset().top - $(window).height() + 100)) {
           // Récupère une fraction du scroll à partir de l'élément pour donner le "pas", la vitesse de déplacement de l'image
           let moveScroll = (window.pageYOffset - ($(section).offset().top - $(window).height())) * 0.15;

           // On part de la position initiale et on ajoute la fraction de scroll
           $(current).css('top', initialPosition + moveScroll + 'px');
         }
       });
     });
   }
 }


 var initFormations = function(){
   if( $('.formations-block').length > 0 ){

       /***************************
       *     RELOAD MORE LIST
       ***************************/
       var load = false;
       var currentPage = $('.formations-block .list').data('paged');
       var maxNumPages = $('.formations-block .list').data('max');
       var postsPerPage = $('.formations-block .list').data('perpage');
       var foundPosts = $('.formations-block .list').data('foundposts');
       var tax = null;

       if (foundPosts > postsPerPage && maxNumPages > 1) {
           $('.formations-block .more').show();
       }
       if(currentPage + 1 > maxNumPages) $('.events-block .more').hide();

       $('.formations-block .taxs a').click(function(e){
         e.preventDefault();
         tax = $(this).data('id');

         $('.formations-block .filters a').removeClass('selected');
         $(this).addClass('selected');

         $.ajax({
             url: $('.formations-block .list').data('url'),
             data: {
                 paged: 1,
                 category_id : tax
             },
             success: function(data) {
                 if (data != '') {

                    currentPage = 1;

                    $('.formations-block .list').html(data);

                     load = false;
                     $('.formations-block .loader').hide();

                     maxNumPages = $('.formations-block .list .datas').data('max');
                     foundPosts = $('.formations-block .list .datas').data('foundposts');

                    if (currentPage == maxNumPages) {
                        $('.formations-block .more').hide();
                    }
                    else {
                        $('.formations-block .more').show();
                    }

                    $('.formations-block .result-count').html($('.formations-block .list .item').length+' / '+foundPosts);
                    $('.formations-block .pages').html('');
                    for(var i=0; i<maxNumPages; i++){
                      $('.formations-block .pages').append('<li></li>');
                    }
                    $('.formations-block .pages li').first().addClass('active');
                 }

             }
         });
       });

       $('.formations-block a.next, .formations-block a.prev').click(function(e){
           e.preventDefault();

           if (!load) {

               load = true;
               $('.formations-block .loader').show();

               if($(this).hasClass('prev')){
                 currentPage = currentPage - 1;
               }
               else{
                 currentPage = currentPage + 1;
               }


               if (currentPage > maxNumPages) {
                 currentPage = 1;
               }
               if (currentPage < 1) {
                 currentPage = maxNumPages;
               }

               $.ajax({
                   url: $('.formations-block .list').data('url'),
                   data: {
                       paged: currentPage,
                       category_id : tax
                   },
                   success: function(data) {
                       if (data != '') {

                          $('.formations-block .list').html(data);

                           load = false;
                           $('.formations-block .loader').hide();

                          if (currentPage == maxNumPages) {
                              $('.formations-block .more').hide();
                          }
                          else {
                              $('.formations-block .more').show();
                          }
                          var total = (postsPerPage * (currentPage-1)) + $('.formations-block .list .item').length;
                          $('.formations-block .result-count').html(total+' / '+foundPosts);
                          $('.formations-block .pages li').removeClass('active');
                          $('.formations-block .pages li').eq((currentPage-1)).addClass('active');
                       }

                   }
               });
           }
       });
  }
 }


  var initMain = function(){
    initHome();
    initMenu();
    initBlocs();
    initThematiques();
    initKeyfigures();
    init_mapbox();
    initMembers();
    initGutenbergColumns();
    initPrograms();
    initAnim();
    initFadeEffect();
    initEvents();
    initNews();
    initFormGreenBox();
    initFormations();
  }

  initMain();

});

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
